import {FormattedSearchItem} from '../types/FormattedSearchResult';
import {SuggestionSearchResult} from '../types/SearchResult';
import {SearchResultVariant} from '../types/SearchResultVariant';
import {getLinkFromVariant} from './FormatterUtil';
import {SEARCH_RESULT_VARIANT} from './../SearchResultRow';

const SUGGESTION_TYPE = {
	RECENTLY_CREATED: 'RECENTLY_CREATED',
	RECENTLY_UPDATED: 'RECENTLY_UPDATED',
	RECENTLY_VISITED: 'RECENTLY_VISITED',
	RECENTLY_ASSIGNED: 'RECENTLY_ASSIGNED',
};

const getSuggestionReasonFromSuggestionType = suggestionType => {
	switch (suggestionType) {
		case SUGGESTION_TYPE.RECENTLY_UPDATED:
			return 'Recently updated';
		case SUGGESTION_TYPE.RECENTLY_VISITED:
			return 'Recently visited';
		case SUGGESTION_TYPE.RECENTLY_ASSIGNED:
			return 'Recently assigned';
		default:
			return '';
	}
};

const getSearchResultVariantFromSuggestionVariant = (suggestionVariant: string): SearchResultVariant => {
	switch (suggestionVariant) {
		case SEARCH_RESULT_VARIANT.PROJECT_GROUP:
			return SearchResultVariant.ProjectGroup;
		case SEARCH_RESULT_VARIANT.PROJECT:
			return SearchResultVariant.Project;
		case SEARCH_RESULT_VARIANT.TASK:
			return SearchResultVariant.Task;
		case SEARCH_RESULT_VARIANT.INTERNAL_TIME:
			return SearchResultVariant.InternalTime;
		default:
			return SearchResultVariant.Suggestion;
	}
};

export interface FormattedSuggestion extends FormattedSearchItem {
	variant: SearchResultVariant;
	companyProjectId: number | null;
	customProjectId?: string;
	projectColor: string;
	projectIndicatorName: string;
	link: string;
}

type SuggestionFormatterInput = {
	searchResult: SuggestionSearchResult;
	trackAndHideSearch: (searchResult, openedInNewTab: boolean) => void;
};

export const suggestionFormatter = ({searchResult, trackAndHideSearch}: SuggestionFormatterInput): FormattedSuggestion => {
	const onSelect = (_, openedInNewTab) => {
		trackAndHideSearch(
			{
				id: searchResult.entityId,
				variant: searchResult.suggestionVariant,
				suggestionType: searchResult.suggestionType,
				isSuggestion: true,
				searchResult,
			},
			!openedInNewTab
		);
	};

	const formattedHighlight = {
		highlightField: getSuggestionReasonFromSuggestionType(searchResult.suggestionType),
	};

	const link = getLinkFromVariant(searchResult.linkId, searchResult.customProjectId, searchResult.suggestionVariant);

	return {
		title: searchResult.entityName,
		name: searchResult.entityName,
		highlight: formattedHighlight,
		variant: getSearchResultVariantFromSuggestionVariant(searchResult.suggestionVariant),
		companyProjectId: searchResult.companyProjectId,
		customProjectId: searchResult.customProjectId,
		projectColor: searchResult.projectColor,
		projectIndicatorName: searchResult.projectName,
		ariaLabel: `Search result. Type: Suggestion. Title: ${searchResult.entityName}. Highlight: ${formattedHighlight.highlightField}`,
		link,
		onSelect,
	};
};
